import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NGXLogger } from 'ngx-logger';
import { Api } from 'src/app/shared/constants/api';
import { DataService } from 'src/app/shared/services/data.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { ExternalEntityService } from '../external-entity.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-sez',
    templateUrl: './sez.component.html',
    styleUrls: ['./sez.component.less'],
    standalone: false
})
export class SEZComponent implements OnInit {

  constructor(private formBuilder:FormBuilder,private entityService:ExternalEntityService,
              private logger:NGXLogger,private dailogRef:MatDialogRef<SEZComponent>,
              private utilityService:UtilityService,@Inject(MAT_DIALOG_DATA) public data:any,
              private service:DataService) { }

  formData=new FormData();
  sezDocument:any;
  sezCtrl=this.formBuilder.control('');
  sezForm:FormGroup;
  showSEZWefAndUpto:boolean=false;
  @Input() buttonHidden:boolean=false;
  resData:any;
  id:number;
  ngOnInit(): void {
    this.initializeForm();
    this.setSezChangeValueEvent();
    this.id=this.data;
    if(this.id){
      this.getBranchById();
    }
  }

  initializeForm(data?:any){
    this.sezForm=this.formBuilder.group({
      sez:[data?data.sez:null],
      sezWEFDate:[data?data.sezWEFDate:null],
      sezValidUptoDate:[data?data.sezValidUptoDate:null]
    })
  }

  setSezChangeValueEvent(event?:any){
    this.sez.valueChanges.subscribe(sezValue => {
      if(sezValue){
        this.showSEZWefAndUpto=true;
        this.sezWEFDate.setValidators([Validators.required]);
        this.sezValidUptoDate.setValidators([Validators.required]);
      } else {
         this.showSEZWefAndUpto=false;
         this.sezWEFDate.clearValidators();
         this.sezWEFDate.reset();
         this.sezValidUptoDate.clearValidators();
         this.sezValidUptoDate.reset();
      } 
    })
  }

  onCancel(){
    this.dailogRef.close();
  }

  onSave(){
    this.sezForm.markAllAsTouched();
    this.resData.sez=this.sez.value;
    this.resData.sezWEFDate=this.sezWEFDate.value;
    this.resData.sezValidUptoDate=this.sezValidUptoDate.value;
    if(this.sezForm.valid){
      this.service.put(Api.ENTITY_BRANCH,this.resData).subscribe(res => {
        this.utilityService.notifier('Branch SEZ details updated successfully','success');
        this.saveFile();
        this.formData.set('referenceId',res.id);
        this.dailogRef.close();
      })
    }
  }

  getBranchById(){
    if(this.id){
      this.service.get(Api.ENTITY_BRANCH+'/'+this.id).subscribe(res => {
        this.getSezDocument(res);
        this.resData=res;
        this.sezForm.patchValue(res);
      })
    }
  }

  getSezDocument(res){
    this.sezDocument=_.findWhere(res?.entityBranchDocuments,{name:"Sez"});
  }

  filesSelected(files){
    if(this.resData?.submittedForApproval){ return; }
    this.formData.set('file',files[0]);
    this.formData.set('referenceName','Entity Branch');
    this.formData.set('code','12');
    this.sezForm.markAsDirty();
  }

  saveFile(){
    this.formData.set('referenceId',this.resData?.id);
    if(this.formData.get('name')!=null){
        if(this.sezDocument){
          this.formData.set('id',this.sezDocument.id);
        }
        this.utilityService.upload(this.formData)
        .subscribe(response=>{
          this.utilityService.notifier('Sez Details updated Successfully','success');
        })
    }
  }

  downloadFile() {
   if(this.resData?.submittedForApproval){ return; }
    if (this.sezDocument) {
      this.service.donwload(this.sezDocument.fileName).subscribe((data: any) => {
        if (data) {
          let url1: string = window.URL.createObjectURL(data);
          window.open(url1);
        }
    });
    }
  }

  get sezWEFDate(){return this.sezForm.get('sezWEFDate');}
  get sezValidUptoDate(){return this.sezForm.get('sezValidUptoDate');}
  get sez(){return this.sezForm.get('sez');}
}
